import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

declare let gtag: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private isInitialized = false;

  constructor(private router: Router, @Inject(PLATFORM_ID) private readonly platformId: any) {}

  public event(eventName: string, params: {}) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    }
  }

  public init(googleAnalyticsKey: string) {
    if (this.platformId !== 'browser' || this.isInitialized) return;
    const key = this.sanitizeKey(googleAnalyticsKey);
    if (!key) return;

    this.isInitialized = true;
    this.listenForRouteChanges(key);

    try {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = 'https://www.googletagmanager.com/gtag/js?id=' + key;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${key}', {'send_page_view': true});
      `;
      document.head.appendChild(script2);
    } catch (ex) {
      console.error('Error appending google analytics');
      console.error(ex);
    }
  }

  private listenForRouteChanges(googleAnalyticsKey: string) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (typeof gtag === 'function') {
          gtag('config', googleAnalyticsKey, {
            page_path: event.urlAfterRedirects,
          });
        }
      }
    });
  }

  public createSchema(schemaCodes) {
    if (this.platformId === 'browser') {
      const script3 = document.createElement('script');
      script3.type = 'application/ld+json';
      script3.innerHTML = schemaCodes;
      document.head.appendChild(script3);
    }
  }

  public createGooglePurchaseTracking(code: string) {
    if (!code) return;
    if (this.platformId === 'browser') {
      const script = document.createElement('script');
      script.setAttribute('id', 'googlePurchaseCode');
      script.type  = "text/javascript";
      script.text = code;
      document.body.appendChild(script);
    }
  }

  private sanitizeKey(key: any): string | null {
    if (!key || typeof key !== 'string') return null;
    const trimmed = key.trim();
    const isValid = /^[A-Za-z0-9\-\_]+$/.test(trimmed);
    return isValid ? trimmed : null;
  }

}
